/**
 * Platform detection for chrome affordances (the ⌘ vs Ctrl modifier). SSR
 * and test-safe: with no navigator it answers false, which renders the
 * Ctrl form, the safe default everywhere but macOS.
 */
export function isMac(): boolean {
  if (typeof navigator === "undefined") return false;
  const probe = `${navigator.platform ?? ""} ${navigator.userAgent ?? ""}`;
  return /Mac|iPhone|iPad|iPod/.test(probe);
}

/** The platform's primary modifier label for shortcut chrome. */
export function modKeyLabel(): string {
  return isMac() ? "⌘" : "Ctrl";
}
